<template>
  <div class="card-container">
    <!--content start -->
    <ion-row>
      <ion-col>
        <ion-card class="cafecard">
          <img
            :src="imageUrl"
            class="radius-img"
            @click="$emit('view-product', product)"
            @error="handleImageError"
          />
          <ion-card-title
            class="h1-card"
            @click="$emit('view-product', product)"
            >{{ product.cafeProducts["name"] }}</ion-card-title
          >
          <span class="price-card">
            $ {{ parseFloat(product.cafeProducts["originalPrice"]).toFixed(2) }}
          </span>
        </ion-card>
      </ion-col>
    </ion-row>
    <!-- content end -->
  </div>
</template>
<script>
import { defineComponent } from "vue";
import {
  IonRow,
  IonCol,
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonIcon,
} from "@ionic/vue";

export default defineComponent({
  name: "cafeItemCard",
  components: {
    IonRow,
    IonCol,
    IonCard,
    IonCardTitle,
    IonCardContent,
    IonIcon,
  },
  props: {
    product: Object,
  },
  data() {
    return {
      imageUrl:
        this.product?.cafeProducts?.productImgUrl ||
        "assets/placeholders/coffee/latte.png",
      defaultImage: "assets/placeholders/coffee/latte.png",
    };
  },
  methods: {
    handleImageError(event) {
      // Prevent infinite loop if default image also fails
      if (event.target && event.target.src) {
        const srcPath = event.target.src.split("/").pop();
        const defaultPath = this.defaultImage.split("/").pop();
        if (srcPath !== defaultPath) {
          this.imageUrl = this.defaultImage;
        }
      }
    },
  },
  watch: {
    "product.cafeProducts.productImgUrl": {
      handler(newUrl) {
        this.imageUrl = newUrl || this.defaultImage;
      },
    },
  },
});
</script>
<style scoped>
.menu-img {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  height: 200px;
  object-fit: cover;
}
.radius-img {
  border-radius: 10px;
}
.card-container {
  float: left;
  width: 50%;
}
.cafecard {
  border: none;
  box-shadow: none;
  margin: 5px 10px 5px 10px;
  border-radius: 2px;
}
.h1-card {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  margin-top: 10px;
  margin-left: 5px;
  margin-bottom: 5px;
}
.price-card {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #f76a4b;
  margin-left: 5px;
}

/* Target iPad Pro (12.9-inch, 11-inch, and other models in portrait mode) */
@media only screen and (min-device-width: 834px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .card-container {
    float: left;
    width: 25%;
  }
}

/* Target iPad Pro (12.9-inch, 11-inch, and other models in landscape mode) */
@media only screen and (min-device-width: 834px) and (max-device-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1.5) {
  .card-container {
    float: left;
    width: 25%;
  }
}
/* iPad Air (3rd generation and later) in portrait */
@media only screen and (min-device-width: 820px) and (max-device-width: 1180px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  .card-container {
    float: left;
    width: 33%;
  }
}

/* iPad Air (3rd generation and later) in landscape */
@media only screen and (min-device-width: 820px) and (max-device-width: 1180px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .card-container {
    float: left;
    width: 33%;
  }
}
</style>
